import { Tooltip } from '@mantine/core'
import { ExternalLink } from 'lucide-react'
import { VerificationOfEmployment } from 'types/graphql'

import DNButton from 'src/components/Buttons/Button/DNButton'
import { canViewVoEResponse } from 'src/lib/voeResponseAccess'

interface VoeActionsProps {
  voe: VerificationOfEmployment
  onViewDetail: (voe: VerificationOfEmployment) => void
}

const VoeActions = ({ voe, onViewDetail }: VoeActionsProps) => {
  const hasResponseContent = canViewVoEResponse(voe)

  return (
    <div className="flex flex-row items-center gap-2">
      <Tooltip
        label="No response content available"
        disabled={hasResponseContent}
      >
        <DNButton
          variant="transparent"
          onClick={() => onViewDetail(voe)}
          disabled={!hasResponseContent}
        >
          <ExternalLink className="stroke-doubleNickel-gray-600" size={16} />
          View details
        </DNButton>
      </Tooltip>
    </div>
  )
}

export default VoeActions
